import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import ClientAuthList from '../auth/ClientAuthList';

const DataStewardList = ({
  handleGridChanges,
  handleEditButtonClick,
  handleDeleteButtonClick,
  toggleShowEditClientAuthModal,
  auths,
  auth,
  showEditClientAuthModal,
  handleEditClientAuthModalAction,
  isAuthorizedUserSearchBoxVisible,
  clientAuthFormValues,
  handleDailyNewsletter,
  receiveDailyNewsletter,
  handleWeeklyNewsletter,
  receiveWeeklyNewsletter,
  handleRealTimeNotification,
  receiveRealTimeNotification,
  receiveRealTimeNotificationForNewPsqArqcSent,
  handleInternalReviewNotification,
  clientId,
  handleAddClientAuthModalAction,
  showAddClientAuthModal,
  toggleShowAddClientAuthModal,
  handleAddClientAuthModalCancelAction,
  handleNewButtonClick,
  myEyError,
  validatingUser,
  handleOnRoleTypeChange,
  addAuthMessageText,
  handleGoToClientOverview,
  handleAddClientAuthModalValidateAction,
  validateDomainWithRole,
  isDataSteward,
  handleDataSteward,
  dataStewardCheckboxDisplay,
  dataStewardValue,
  showDSError,
  buttonVarient,
  clientUserSearchText,
  handleSearchChange,
  handleClearSearchText,
}) => {
  return (
    <>
      <ClientAuthList
        auths={auths}
        auth={auth}
        handleGridChanges={handleGridChanges}
        handleEditButtonClick={handleEditButtonClick}
        showEditClientAuthModal={showEditClientAuthModal}
        handleEditClientAuthModalAction={handleEditClientAuthModalAction}
        toggleShowEditClientAuthModal={toggleShowEditClientAuthModal}
        isAuthorizedUserSearchBoxVisible={isAuthorizedUserSearchBoxVisible}
        clientAuthFormValues={clientAuthFormValues}
        handleDailyNewsletter={handleDailyNewsletter}
        receiveDailyNewsletter={receiveDailyNewsletter}
        handleWeeklyNewsletter={handleWeeklyNewsletter}
        receiveWeeklyNewsletter={receiveWeeklyNewsletter}
        handleRealTimeNotification={handleRealTimeNotification}
        receiveRealTimeNotification={receiveRealTimeNotification}
        receiveRealTimeNotificationForNewPsqArqcSent={
          receiveRealTimeNotificationForNewPsqArqcSent
        }
        handleInternalReviewNotification={handleInternalReviewNotification}
        handleDeleteButtonClick={handleDeleteButtonClick}
        showAddClientAuthModal={showAddClientAuthModal}
        toggleShowAddClientAuthModal={toggleShowAddClientAuthModal}
        handleAddClientAuthModalCancelAction={
          handleAddClientAuthModalCancelAction
        }
        addAuthMessageText={addAuthMessageText}
        handleAddClientAuthModalValidateAction={
          handleAddClientAuthModalValidateAction
        }
        validateDomainWithRole={validateDomainWithRole}
        validatingUser={validatingUser}
        myEyError={myEyError}
        handleOnRoleTypeChange={handleOnRoleTypeChange}
        handleNewButtonClick={handleNewButtonClick}
        handleAddClientAuthModalAction={handleAddClientAuthModalAction}
        isDataSteward={isDataSteward}
        handleDataSteward={handleDataSteward}
        dataStewardCheckboxDisplay={dataStewardCheckboxDisplay}
        showDSError={showDSError}
        handleGoToClientOverview={handleGoToClientOverview}
        clientId={clientId}
        dataStewardValue={dataStewardValue}
        parentComponent="DataSteward"
        clientUserSearchText={clientUserSearchText}
        handleSearchChange={handleSearchChange}
        handleClearSearchText={handleClearSearchText}
      />
    </>
  );
};

DataStewardList.propTypes = {
  handleGridChanges: PropTypes.func,
  handleEditButtonClick: PropTypes.func,
  handleDeleteButtonClick: PropTypes.func,
  toggleShowEditClientAuthModal: PropTypes.func,
  auths: PropTypes.array,
  auth: PropTypes.object,
  showEditClientAuthModal: PropTypes.bool,
  handleEditClientAuthModalAction: PropTypes.func,
  isAuthorizedUserSearchBoxVisible: PropTypes.bool,
  clientAuthFormValues: PropTypes.object,
  handleDailyNewsletter: PropTypes.func,
  receiveDailyNewsletter: PropTypes.bool,
  handleWeeklyNewsletter: PropTypes.func,
  receiveWeeklyNewsletter: PropTypes.bool,
  handleRealTimeNotification: PropTypes.func,
  receiveRealTimeNotification: PropTypes.bool,
  receiveRealTimeNotificationForNewPsqArqcSent: PropTypes.bool,
  handleInternalReviewNotification: PropTypes.func,
  clientId: PropTypes.number,
  handleAddClientAuthModalAction: PropTypes.func,
  showAddClientAuthModal: PropTypes.bool,
  toggleShowAddClientAuthModal: PropTypes.func,
  handleAddClientAuthModalCancelAction: PropTypes.func,
  handleNewButtonClick: PropTypes.func,
  myEyError: PropTypes.string,
  validatingUser: PropTypes.bool,
  handleOnRoleTypeChange: PropTypes.func,
  addAuthMessageText: PropTypes.string,
  handleGoToClientOverview: PropTypes.func,
  handleAddClientAuthModalValidateAction: PropTypes.func,
  validateDomainWithRole: PropTypes.func,
  isDataSteward: PropTypes.bool,
  handleDataSteward: PropTypes.func,
  dataStewardCheckboxDisplay: PropTypes.bool,
  dataStewardValue: PropTypes.bool,
  showDSError: PropTypes.bool,
  buttonVarient: PropTypes.string,
  clientUserSearchText: PropTypes.string,
  handleSearchChange: PropTypes.func,
  handleClearSearchText: PropTypes.func,
};

export default DataStewardList;
